var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("a-tabs", {
    key: _vm.activeKey,
    attrs: {
      activeKey: _vm.activeKey
    },
    on: {
      change: _vm.tabChange
    }
  }, [_c("a-tab-pane", {
    key: 1,
    attrs: {
      tab: _vm.$t("基本信息")
    }
  }, [_vm.customerInsuranceId == -1 || _vm.mark && _vm.customerInsuranceId != -1 ? _c("basic-info", {
    attrs: {
      customerInsuranceId: Number(_vm.customerInsuranceId),
      mark: _vm.mark
    },
    on: {
      next: _vm.nextFun
    }
  }) : _vm._e()], 1), _c("a-tab-pane", {
    key: 2,
    attrs: {
      tab: _vm.$t("二维码模版"),
      disabled: _vm.disabled
    }
  }, [_c("code-info", {
    attrs: {
      customerInsuranceId: Number(_vm.customerInsuranceId),
      insuranceId: Number(_vm.insuranceId)
    },
    on: {
      previous: function ($event) {
        _vm.activeKey = 1;
      },
      next: _vm.nextFun
    }
  })], 1), _c("a-tab-pane", {
    key: 3,
    attrs: {
      tab: _vm.$t("内容管理")
    }
  }, [_c("contents", {
    attrs: {
      customerInsuranceId: Number(_vm.customerInsuranceId)
    },
    on: {
      previous: _vm.previousFun,
      next: _vm.nextFun
    }
  })], 1), _c("a-tab-pane", {
    key: 4,
    attrs: {
      tab: _vm.$t("产品方案")
    }
  }, [_c("plan-list", {
    attrs: {
      customerInsuranceId: Number(_vm.customerInsuranceId),
      insuranceId: Number(_vm.insuranceId),
      customerId: _vm.customerId
    },
    on: {
      previous: function ($event) {
        _vm.activeKey = 3;
      },
      next: _vm.nextFun
    }
  })], 1), _c("a-tab-pane", {
    key: 5,
    attrs: {
      tab: _vm.$t("配置模板")
    }
  }, [_c("configuration-template", {
    attrs: {
      customerInsuranceId: Number(_vm.customerInsuranceId),
      insuranceId: Number(_vm.insuranceId),
      customerId: _vm.customerId,
      productName: _vm.productName,
      applicationId: _vm.applicationId
    },
    on: {
      previous: function ($event) {
        _vm.activeKey = 4;
      }
    }
  })], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };